import { Button, Modal, ModalBody, ModalContent } from "@heroui/react";
import { BadgeCheckIcon } from "lucide-react";
import { formatUnits } from "viem";
import type { BridgeClaimParams, BridgeTxUnclaimedSuccess } from "../../state/types";
import { formatTimestamp } from "../../utils";
import { TxHashLink } from "../TxHashLink";
import { BridgeCard } from "./BridgeCard";

export function BridgeSuccessModal({
  isOpen,
  onClose,
  unclaimedTxData,
  onClaim,
}: {
  isOpen: boolean;
  onClose: () => void;
  unclaimedTxData: BridgeTxUnclaimedSuccess | null;
  onClaim: (claimData: BridgeClaimParams) => void;
}) {
  if (!unclaimedTxData) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody className="flex items-center gap-4 p-8">
          <BadgeCheckIcon className="size-24 stroke-1 text-green-500/90 fill-green-500/10 " />

          <p className="font-semibold text-large">Bridge completed!</p>

          <BridgeCard
            bridgeType={unclaimedTxData.bridgeType}
            displayAmount={Number(formatUnits(unclaimedTxData.amount, unclaimedTxData.tokenDecimals))}
            tokenSymbol={unclaimedTxData.tokenSymbol}
          />

          <div className="flex flex-col gap-2 w-full">
            <div className="flex justify-between w-full">
              <div className="text-[#ADC0D0]">Date & time</div>
              <div className="font-semibold">{formatTimestamp(unclaimedTxData.timestamp)}</div>
            </div>

            <div className="flex justify-between w-full">
              <div className="text-[#ADC0D0]">Transaction Hash</div>
              <div className="font-semibold">
                <TxHashLink
                  txHash={unclaimedTxData.txHash}
                  source={unclaimedTxData.bridgeType === "deposit" ? "l1" : "l2"}
                />
              </div>
            </div>
          </div>

          <Button
            fullWidth
            color="primary"
            size="lg"
            radius="full"
            onPress={() => {
              onClaim({
                ...unclaimedTxData,
                isManualClaim: false,
              });
            }}
          >
            Claim tokens
          </Button>

          <p className="text-small text-[#AEC4D3]">
            Click claim to claim tokens on the Aztec network, without doing so, tokens will not appear in your wallet.
          </p>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
